import { render } from "./DoubleGraph.vue?vue&type=template&id=28c105cc"
import script from "./DoubleGraph.vue?vue&type=script&lang=js"
export * from "./DoubleGraph.vue?vue&type=script&lang=js"

import "./DoubleGraph.vue?vue&type=style&index=0&id=28c105cc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__